import React, { useState } from 'react';
import './VirtualCFO.css';

function Taxation() {
  const [activeIndex, setActiveIndex] = useState(null);

  const offerings = [
    {
      title: 'Corporate Tax Planning',
      content: [
        'Designing efficient corporate tax strategies',
        'Advisory on domestic and international taxation laws',
        'Minimizing tax liability through legal structuring',
        'Year-end tax planning and forecasting'
      ]
    },
    {
      title: 'Tax Compliance & Filing',
      content: [
        'Preparation and filing of income tax returns',
        'Handling tax assessments and notices',
        'Advance tax computation and e-filing',
        'Withholding tax (TDS/TCS) compliance'
      ]
    },
    {
      title: 'Transfer Pricing',
      content: [
        'Benchmarking studies for related party transactions',
        'TP documentation as per Indian and OECD norms',
        'Advisory and compliance support for cross-border deals',
        'Representation before tax authorities'
      ]
    },
    {
      title: 'International Tax Advisory',
      content: [
        'Double Tax Avoidance Agreement (DTAA) analysis',
        'Permanent establishment and BEPS consulting',
        'Global tax optimization for MNCs and startups',
        'Cross-border transaction structuring'
      ]
    },
    {
      title: 'Litigation & Representation',
      content: [
        'Drafting and filing of appeals and representations',
        'Appearing before tax authorities and tribunals',
        'Handling scrutiny, reassessment, and penalty cases',
        'Support during income tax audits and raids'
      ]
    }
  ];

  const toggleAccordion = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <div className="service-page">
      {/* Hero Section */}
      <section
        className="hero-image-section"
        style={{ backgroundImage: "url('/images/taxation-hero.png')" }}
      >
        <div className="hero-text-container">
          <h1>Corporate Taxation Services</h1>
          <p>Helping you comply your corporate tax needs with a focussed strategy</p>
        </div>
      </section>

      {/* Content Section */}
      <section className="service-content">
        <div className="content-left">
          <h2>Guiding Your Success through the Taxation.</h2>
          <p>We help clients execute industry-specific taxation strategies that allow them to realize exceptional business value.</p>
          <p>Steadfast Business Consulting services clients across various verticals as they navigate an increasingly complex tax landscape under both national and international guidelines.</p>
          <p>Our corporate tax services can help solve your tax challenges, offering in-depth, up-to-date knowledge of the relevant local rules and regulations and helping you keep up with the ever-changing regulations.</p>
          <p>The evolution of the taxation framework has become very complex. This is majorly due to an increase in cross-border business models.</p>
          <p>Managing such complexity has become necessary for enterprises to maximize value from every important business decision.</p>
          <p>The Online tax consultancy services ensure that you maintain compliance, and we also make sure that we create value for your business, giving you the best tax advice & assistance.</p>
        </div>
      </section>

      {/* Accordion Section */}
      <section className="accordion-section">
        <h2>Our Offerings</h2>
        <div className="accordion-container">
          {offerings.map((item, index) => (
            <div key={index} className={`accordion-item ${activeIndex === index ? 'active' : ''}`}>
              <div className="accordion-header" onClick={() => toggleAccordion(index)}>
                <span>{activeIndex === index ? '−' : '+'}</span> {item.title}
              </div>
              {activeIndex === index && (
                <div className="accordion-body">
                  <ul>
                    {item.content.map((point, idx) => (
                      <li key={idx}>{point}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default Taxation;





